import { render, staticRenderFns } from "./ReservationCatalogue.vue?vue&type=template&id=6ed0f7aa&scoped=true"
import script from "./ReservationCatalogue.vue?vue&type=script&lang=js"
export * from "./ReservationCatalogue.vue?vue&type=script&lang=js"
import style0 from "./ReservationCatalogue.vue?vue&type=style&index=0&id=6ed0f7aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed0f7aa",
  null
  
)

export default component.exports